import "./styles/main.css";
import { initRouter, onPageChange, goTo } from "./router";
import { initFormulairePage, resetFormulairePage } from "./pages/formulaire";
import type { PageId } from "./types";

function bootstrap(): void {
  initRouter();
  initFormulairePage();

  onPageChange((page: PageId) => {
    if (page === "formulaire") {
      resetFormulairePage();
    }
  });

  // Utile pour du debug manuel dans la console du navigateur.
  (window as unknown as { startaiGoTo: typeof goTo }).startaiGoTo = goTo;
}

document.addEventListener("DOMContentLoaded", bootstrap);
